/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAction, props } from '@ngrx/store';
import {
    CreateMagayaNetworkConfigurationPayload,
    MagayaNetworkConfigurationEntity,
    UpdateMagayaNetworkConfigurationPayload,
} from './magaya-network-configuration.models';
import { Hub } from '@qwyk/models';

export const init = createAction(
    '[MagayaNetworkConfiguration Page] Init',
    props<{ organization: Hub.Organization }>()
);

export const loadMagayaNetworkConfigurationSuccess = createAction(
    '[Hub/Console/MagayaNetworkConfiguration] Load MagayaNetworkConfiguration Success',
    props<{ magayaNetworkConfiguration: MagayaNetworkConfigurationEntity }>()
);

export const loadMagayaNetworkConfigurationFailure = createAction(
    '[Hub/Console/MagayaNetworkConfiguration] Load MagayaNetworkConfiguration Failure',
    props<{ error: any }>()
);

export const createMagayaNetworkConfiguration = createAction(
    '[Hub/Console/MagayaNetworkConfiguration] Create MagayaNetworkConfiguration',
    props<{ payload: CreateMagayaNetworkConfigurationPayload }>()
);

export const createMagayaNetworkConfigurationSuccess = createAction(
    '[Hub/Console/MagayaNetworkConfiguration] Create MagayaNetworkConfiguration Success',
    props<{ magayaNetworkConfiguration: MagayaNetworkConfigurationEntity }>()
);

export const createMagayaNetworkConfigurationFailure = createAction(
    '[Hub/Console/MagayaNetworkConfiguration] Create MagayaNetworkConfiguration Failure',
    props<{ error: any }>()
);

export const updateMagayaNetworkConfiguration = createAction(
    '[Hub/Console/MagayaNetworkConfiguration] Update MagayaNetworkConfiguration',
    props<{
        entity: MagayaNetworkConfigurationEntity;
        payload: UpdateMagayaNetworkConfigurationPayload;
    }>()
);

export const updateMagayaNetworkConfigurationSuccess = createAction(
    '[Hub/Console/MagayaNetworkConfiguration] Update MagayaNetworkConfiguration Success',
    props<{ magayaNetworkConfiguration: MagayaNetworkConfigurationEntity }>()
);

export const updateMagayaNetworkConfigurationFailure = createAction(
    '[Hub/Console/MagayaNetworkConfiguration] Update MagayaNetworkConfiguration Failure',
    props<{ error: any }>()
);

export const testMagayaNetworkConfiguration = createAction(
    '[Hub/Console/MagayaNetworkConfiguration] Test MagayaNetworkConfiguration',
    props<{ organization: Hub.Organization }>()
);

export const testMagayaNetworkConfigurationSuccess = createAction(
    '[Hub/Console/MagayaNetworkConfiguration] Test MagayaNetworkConfiguration Success',
    props<{ magayaNetworkConfiguration: MagayaNetworkConfigurationEntity }>()
);

export const testMagayaNetworkConfigurationFailure = createAction(
    '[Hub/Console/MagayaNetworkConfiguration] Test MagayaNetworkConfiguration Failure',
    props<{ error: any }>()
);

export const dismissError = createAction(
    '[Hub/Console/MagayaNetworkConfiguration] Dismiss Error'
);
